// extracted by mini-css-extract-plugin
export default {"container":"Play_container__JftVm","box_btn":"Play_box_btn__B5OCW","btn_window":"Play_btn_window__8hx6x"};